import { Link } from '@cambridgeassessment/cambridge-ui';
import { Box, Container, Typography } from '@material-ui/core';
import React, { memo } from 'react';
import { GACategory } from 'src/types';
import { sendGAEvent } from 'src/utils/googleAnalytics';
import useAuth from '../../hooks/useAuth';
import usePlatformTiles from '../../hooks/usePlatformTiles';
import AccountCard from '../AccountCard/AccountCard';
import Products from '../Products/Products';
import envVariables from './../../env';
import { home } from './constants';
import { useHomePageStyles } from './styles';

const HomePage: React.FC = () => {
  const { user } = useAuth();
  const { products, isLoading } = usePlatformTiles();
  const classes = useHomePageStyles();
  return (
    <Container disableGutters maxWidth="xl">
      <Box>
        <AccountCard user={user} />
      </Box>
      <Box mt={4} mb={4}>
        <Typography variant="h3">My services</Typography>
      </Box>
      {!isLoading && products.length > 0 ? (
        <Products />
      ) : (
        !isLoading && (
          <Typography variant="body1">
            You do not have any services available to use at the moment.
          </Typography>
        )
      )}
      {isLoading && <Products />}
      <Box my={4}>
        {user.organisations.length > 0 ? (
          <Typography variant="h4">
            You might also be interested in...
          </Typography>
        ) : (
          <Box my={4}></Box>
        )}
      </Box>

      {user.organisations.length > 0 ? (
        home.externalLinks.map(({ title, description, url }) => (
          <Box key={title} mb={4}>
            <Link
              href={url}
              underline="none"
              data-testid="test-link-title"
              onClick={() =>
                sendGAEvent(
                  GACategory.externalLinks,
                  `${user.roles} clicked on ${title} link`
                )
              }
            >
              {title}
            </Link>
            <Box mt={1}>
              <Typography className={classes.paragraph} variant="body1">
                {description}
              </Typography>
            </Box>
          </Box>
        ))
      ) : (
        <Box my={4}></Box>
      )}
      {user.organisations.length > 0 &&
      user.organisationId === envVariables.CA_BPID ? (
        home.internalLinks.map(({ title, description, url }) => (
          <Box key={title} mb={4}>
            <Link
              href={url}
              underline="none"
              data-testid="test-link-title"
              onClick={() =>
                sendGAEvent(
                  GACategory.internalLinks,
                  `${user.roles} clicked on ${title} link`
                )
              }
            >
              {title}
            </Link>
            &nbsp;&nbsp;
            <Box className={classes.internalLink} component="label">
              INTERNAL LINK
            </Box>
            <Box mt={1}>
              <Typography variant="body1">{description}</Typography>
            </Box>
          </Box>
        ))
      ) : (
        <Box my={4}></Box>
      )}
    </Container>
  );
};

export default memo(HomePage);
